<template>
    <div>
        <loading :active.sync="isLoaderVisible"></loading>
        <div class="form-group">
            <label for="isMarketingEvent" class="col-sm-2 control-label">
                Marketing to?:
            </label>
            <div class="col-sm-6">
                <div class="radio">
                    <label for="attachInvoiceYes" class="radio-inline">
                        <input type="radio" name="isMarketingEvent" id="marketingEventNo" value="No" 
                               v-model="timeEntry.isMarketingEvent" @change="clearContact()" :disabled="timeEntry.isAuditEdit">
                        Contact/Company
                    </label>
                    <label for="attachInvoiceNo" class="radio-inline">
                        <input type="radio" name="isMarketingEvent" id="attachInvoiceYes" value="Yes" 
                               v-model="timeEntry.isMarketingEvent" @change="setMarketingEvent()" :disabled="timeEntry.isAuditEdit">
                        An Event
                    </label>
                </div>
            </div>
        </div>
        <div class="form-group" v-if="timeEntry.isMarketingEvent === 'No'">
            <label for="fileId" class="col-sm-2 control-label">
                Who:
            </label>
            <div class="col-sm-10 col-md-8 col-lg-6">
                <template v-if="timeEntry.marketingLocationId > 0">
                    {{ timeEntry.marketingContactLabel }}
                    <a id="MarketingContactPicker" class="btn btn-link change" @click="pickContact(pickerUrl)">Change Contact</a>
                </template>
                <template v-else>
                    <a id="MarketingContactPicker" class="btn btn-link" @click="pickContact(pickerUrl)">Choose Contact</a>
                </template>
                <p class="text-danger" v-if="errors.has('marketingLocationId')">{{ errors.first('marketingLocationId') }}</p>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from "vue";
    import axios from 'axios';
    import Loading from 'vue-loading-overlay';

    export default {
        inject: ['$validator'],
        data: function () {
            return {
                timeEntry: this.$store.state.timeEntry,
                isLoaderVisible: false,
                fileIdErrorMessage: "",
                pickerBaseUrl: "/core/contacts/picker?caller=Marketing&returnPage=%2Fcore%2Ftimeexpense%23marketing%2Fcontinue"
            };
        },
        components: { Loading },
        methods: {
            pickContact(url) {
                this.$emit('contactPickerClick', url);
            },
            clearContact() {
                this.timeEntry.marketingContactId = null;
                this.timeEntry.marketingLocationId = null;
                this.timeEntry.marketingContactLabel = "";
            },
            setMarketingEvent() {
                this.timeEntry.marketingContactId = 0;
                this.timeEntry.marketingLocationId = 14346;  // Special Location for Events (t_location table)
                this.timeEntry.marketingContactLabel = "";
            }
        },
        computed: {
            pickerUrl() {
                var url = this.pickerBaseUrl;

                if (this.timeEntry.marketingLocationId) {
                    url += "&loc=" + this.timeEntry.marketingLocationId;

                    if (this.timeEntry.marketingContactId) {
                        url += "&con=" + this.timeEntry.marketingContactId;
                    }
                }

                return url;
            }
        }
    };
</script>

